const SituacaoForm = {
    ABERTO: 1,
    GRID: 'grid',
    TODOS: 'todos'
};

export default SituacaoForm;
